/* eslint-disable radix */
/* eslint-disable no-useless-return */

import { hasValue, isNullOrUndefined, safeParseJSON } from '../general-helpers';

export const getNumberFromSessionStorage = (key = '') => {
    try {
        return parseInt(sessionStorage.getItem(key) || '');
    } catch (error) {
        return 0;
    }
};

export const setNumberInSessionStorage = (key, value) => {
    if (isNullOrUndefined(value)) {
        return;
    }

    try {
        sessionStorage.setItem(key, value.toString());
    } catch (error) {
        return;
    }
};

export const deleteFromSessionStorage = (key) => {
    try {
        sessionStorage.removeItem(key);
    } catch (error) {
        return;
    }
};

export const deleteItemsFromSessionStorage = (keys) => {
    if (!hasValue(keys)) {
        return;
    }

    keys.forEach((key) => {
        deleteFromSessionStorage(key);
    });
};

export const getStringFromSessionStorage = (key) => {
    try {
        return sessionStorage.getItem(key);
    } catch (error) {
        return '';
    }
};

export const setSessionStorageItem = (key, value) => {
    if (isNullOrUndefined(value)) {
        return;
    }

    try {
        sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        return;
    }
};

export const getSessionStorageItem = (key, deleteItem = false) => {
    try {
        const item = safeParseJSON(sessionStorage.getItem(key));

        if (deleteItem) {
            sessionStorage.removeItem(key);
        }

        return item;
    } catch (error) {
        return undefined;
    }
};

export const getSessionStorageItems = (keys = []) => {
    const result = {};

    if (!hasValue(keys)) {
        return {};
    }

    keys.forEach((key) => {
        result[key] = getSessionStorageItem(key);
    });

    return result;
};
